// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paiement_status_modal_content {
    background: #fff;
    border-radius: 8px;
    width: 90%;
    max-width: 400px;
    padding: 32px 24px;
    text-align: center;
}

.status_icon {
    font-size: 48px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: #fff;
}

.status_icon.success {
    background: #28a745;
}

.status_icon.failed {
    background: #dc3545;
}

.status_title {
    margin-bottom: 8px;
}

.status_description {
    color: #666;
    margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/paiements/PaiementStatusModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".paiement_status_modal_content {\n    background: #fff;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 400px;\n    padding: 32px 24px;\n    text-align: center;\n}\n\n.status_icon {\n    font-size: 48px;\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 16px;\n    color: #fff;\n}\n\n.status_icon.success {\n    background: #28a745;\n}\n\n.status_icon.failed {\n    background: #dc3545;\n}\n\n.status_title {\n    margin-bottom: 8px;\n}\n\n.status_description {\n    color: #666;\n    margin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
